import { InjectionToken } from '@angular/core';
import { MapConfiguration } from '../../../../core/contract/user-configuration/map-configuration.contract';
import { OrganisationColumnKeys } from '../../../../pages/organisations/enums/organisation-column-keys.enum';
import { ContactColumnKeys } from '../../../../pages/resources/contacts/enums/contact-column-keys.enum';
import { EquipmentColumnKeys } from '../../../../pages/resources/equipment/enums/equipment-column-keys.enum';
import { MapsConfig } from '../contract/map-config.contract';
import { MapLocationsPayload } from '../contract/map-locations-payload.contract';
import { getSVGMarkerCircle } from '../utils/map-marker-utils';

export const MAPS_CONFIG = new InjectionToken<MapsConfig>('angular-google-maps MAPS_CONFIG');
export const MIN_ZOOM = 1;
export const MAX_ZOOM = 22;
export const DEFAULT_CLUSTER_RADIUS = 60;
export const DEFAULT_MULTI_POSITION_ZOOM = 15;
export const DEFAULT_SINGLE_POSITION_ZOOM = 5;
export const DEFAULT_POSITION_FALLBACK = { lat: 50.9333, lon: 10.5833 };
export const DEFAULT_REFRESH_MS = 60000;
export const MIN_AUTO_REFRESH_MS = 5000;
export const DEFAULT_CLUSTER_COLOR = '#0965B1';
export const GOOGLE_MAP_URL = 'https://www.google.com/maps';
export const MAP_ICON_MARKER = getSVGMarkerCircle('#FC7800');   // Default circle marker
export const MAP_ICON_MARKER_GREEN = 'assets/icons/googlemaps-marker-icons/map-icon-marker-green.svg';
export const MAP_ICON_MARKER_RED = 'assets/icons/googlemaps-marker-icons/map-icon-marker-red.svg';
export const MAP_ICON_MARKER_BLUE = 'assets/icons/googlemaps-marker-icons/map-icon-marker-blue.svg';
export const MAP_ICON_MARKER_TEST = 'assets/icons/googlemaps-marker-icons/map-icon-marker-TEST.svg';
export const MAP_ICON_CLUSTER = 'assets/icons/googlemaps-cluster-icons/map-icon-cluster.svg';
export const MAP_ICON_MARKER_SIZE = 16;
export const MAP_ICON_CLUSTER_SIZE = 65;

export const DEFAULT_MAP_CONFIGURATION: MapConfiguration = {
  showEquipments: true,
  showProjects: false,
  showOrganisations: false,
  showContacts: false,
  showStocks: false,
  showGeofences: false,
  equipmentColumn: EquipmentColumnKeys.NAME,
  projectColumn: 'projectNone',
  organisationColumn: OrganisationColumnKeys.ORGANISATION_NONE,
  stockColumn: 'stockNone',
  contactColumn: ContactColumnKeys.NAME,
  gridSize: 30,
};
export const getEmptyMapLocationPayload = <T>(): MapLocationsPayload<T> => ({
  centerMap: false,
  locations: [] as T[],
});
